import { useState as n, useLayoutEffect as o } from "react";
const r = () => {
  const [i, t] = n({
    width: void 0,
    height: void 0
  });
  return o(() => {
    const e = () => t({
      width: window?.innerWidth || void 0,
      height: window?.innerHeight || void 0
    });
    return window.addEventListener("resize", e), e(), () => window.removeEventListener("resize", e);
  }, []), i;
};
export {
  r as useWindowSize
};
